import type { ReactNode } from 'react';

import { AllocabLogo } from './AllocabLogo';

interface PublicShellProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}

/** Gabarit des pages publiques (connexion, acceptation d'invitation). */
export const PublicShell = ({ title, subtitle, children, footer }: PublicShellProps) => (
  <main className="min-h-viewport flex flex-col items-center justify-center bg-zinc-50 px-4">
    <div className="w-full max-w-[380px] flex flex-col gap-7 py-12">
      <header className="flex flex-col gap-3 items-center text-center">
        <AllocabLogo className="h-6 w-auto text-zinc-900" />
        <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 mt-2">{title}</h1>
        {subtitle ? <p className="text-sm text-zinc-500 leading-relaxed">{subtitle}</p> : null}
      </header>

      {children}

      {footer ? <p className="text-xs text-zinc-500 text-center">{footer}</p> : null}
    </div>
  </main>
);
